<template>

    <div class="want-price clearfix main-want-price" id="want-price">
        <div class="wrapper clearfix">
            <div class="col-md-120">
                <h2>УЗНАЙТЕ САМУЮ НИЗКУЮ ЦЕНУ В СЕРВИСЕ РЯДОМ С ВАМИ.<br>ЭТО БЕСПЛАТНО.</h2>
                <div id="application">
                    <div class="col-lg-30 col-md-40 col-sm-60">
                        <div class="field" id="application-brand-field">
                            <select id="order-form-mark" title="Марка" name="brand" v-model="user.mark" class="select2"></select>
                        </div>
                    </div>
                    <div class="col-lg-30 col-md-40 col-sm-60">
                        <div class="field select-models">
                            <select id="order-form-model" title="Модель" name="model" v-model="user.model" disabled class="select2"></select>
                        </div>
                    </div>
                    <div class="col-lg-30 col-md-40 col-sm-60">
                        <div class="field">
                            <input id="order-form-phone" type="tel" name="phone" data-inputmask="'mask': ['999999999999', '+9(999) 999-9999', '+999 99-99-9999', '+999 99-999-999', '+99(999)999-99-99']" v-model="user.phone"  placeholder="Ваш номер телефона">
                        </div>
                    </div>
                    <div class="col-lg-30 col-md-40 col-sm-60 addfield4" style="display:none;">
                        <div class="field">
                            <input type="number" min="1970" max="2019" v-model="user.year"
                                   name="release_year" placeholder="Год выпуска"
                            >
                        </div>
                    </div>
                    <div class="col-lg-30 col-md-40 col-sm-60 addfield4">
                        <div class="field">
                            <select id="order-form-category-parent" name="category_parent" v-model="category" class="select2"></select>
                        </div>
                    </div>
                    <div class="col-lg-30 col-md-40 col-sm-60 addfield4">
                        <div class="field">
                            <select id="order-form-category" name="category" class="select2" v-model="job" disabled></select>
                        </div>
                    </div>
                    <div class="col-lg-30 col-md-40 col-sm-60 addfield1" style="display: none;">
                        <div class="field">
                            <input name="vin" type="text" v-model="user.vin" placeholder="VIN-код" >
                        </div>
                    </div>
                    <div class="col-lg-30 col-md-40 col-sm-60 addfield5"  style="display:none;">
                        <div class="field">
                            <select id="order-form-city" name="city_id" v-model="citys" class="js-example-basic-single select2 form-control">
                                <option :value="city.id" selected>{{city.name}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-xs-120 addfield7" style="display: none;">
                        <div class="field width-100">
                            <input name="problem" type="text" v-model="problem" class="width-100" placeholder="Опишите проблему">
                        </div>
                    </div>
                    <div class="col-lg-30 col-md-40 col-sm-60 addfield8" style="display: none;">
                        <div class="field">
                            <input name="name" type="text" v-model="user.name" placeholder="Ваше имя">
                        </div>
                    </div>

                    <div class="col-lg-30 col-md-40 col-sm-60">
                        <div class="field">
                            <input name="name" type="text" v-model="promocode" placeholder="Промокод от друга">
                        </div>
                    </div>
                    <div class="col-lg-30 col-md-40 col-sm-60 addfield2" style="display: none;">
                        <div class="field">
                            <input name="email" type="email" v-model="user.email" placeholder="Email"
                                   title="Пример: example@mail.ru"
                            >
                        </div>
                    </div>
                    <div class="col-lg-30 col-md-40 col-sm-60 addfield3" style="display: none;">
                        <div class="field">
                            <input id="order-form-district" name="district" type="text" v-model="user.district" placeholder="В каком районе найти сервис">
                        </div>
                    </div>
                    <div class="col-lg-30 col-md-40 col-sm-60" id="select-add-field">
                        <div class="field">
                            <select id="select-add-field_select" class="js-example-basic-single select2 form-control">
                                <option selected>еще (не обязательные поля)</option>
                                <option value="1">VIN-код</option>
                                <option value="2">Email</option>
                                <option value="3">В каком районе найти сервис</option>
                                <option value="4">Год выпуска</option>
                                <option value="5">Город</option>
                                <option value="7">Опишите проблему</option>
                                <option value="8">Ваше имя</option>
                                <option value="9">Прикрепить файл</option>
                                <option value="10">Удобное время</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-lg-30 col-md-40 col-sm-60 addfield9" style="display: none;">
                        <div class="add-photo">
                            <label for="file" style="cursor: pointer;" data-toggle="tooltip" title="Вы можете прикрепить файл к заявке">
                                <img src="/static/img/general/tooltip.png">
                                <span>Прикрепить файл</span>
                                <img src="/static/img/general/add-photo-plus.png">
                            </label>
                            <input type="file" id="file" name="files[]" multiple class="hidden" ref="file" v-on:change="handleFileUpload()">
                            <div class="images">
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-120">
                        <div class="time addfield10" style="display: none;">
                            <span>Мне удобно посетить сервис</span>
                            <input name="date" id="date_c" type="date" v-model="date">
                            <span>в</span>
                            <input name="time" type="time" v-model="time">
                        </div>
                        <div class="get-offer">
                            <button  id="sendHide" type="submit" @click="sendLead"
                                     style="margin-top: 10px;">Получить лучшие предложения от сервисов!</button>
                        </div>
                        <div class="error alert alert-danger" v-if="errors.length > 0">
                            <p v-for="(error, index) in errors" :key="index">{{error}}</p>
                        </div>
                        <div class="agree">
                            <label>
                                <input type="checkbox"  name="rules" v-model="check">
                                <span>Я соглашаюсь с <router-link to="/pol-zovatel-skoe-soglashenie/" target="_blank">условиями обработки персональных данных</router-link></span>
                            </label>
                        </div>
                    </div>
                    <input type="hidden" name="stock" v-model="stock" value="Нет">
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from '@/router/http'
import $ from 'jquery'
import 'select2'
import Inputmask from 'inputmask'
export default {
  name: 'index-form',
  props: ['city', 'user', 'auth', 'service'],
  data () {
    return {
      category: '',
      job: '',
      citys: this.$root.city.id,
      errors: [],
      problem: '',
      file: null,
      date: '',
      time: '',
      stock: '',
      check: 0,
      brands: [],
      marks: [],
      cityl: [],
      cats: [],
      promocode: null
    }
  },
  methods: {
    sendLead () {
      this.errors = []
      if (!this.user.phone && !this.user.email) this.errors.push('Вам необходимо указать email или телефон')
      if (!this.citys) this.errors.push('Вам необходимо выбрать город')
      if (!this.check) this.errors.push('Вам необходимо принять условия обработки данных')
      if (this.errors.length === 0) {
        setTimeout(function () { alert('Ваша заявка отправлена, в ближайшее время мы с Вами свяжемся') }, 1)
        var formData = new FormData()
        var notes = []
        if (this.category) notes.push('Категория работ: ' + (this.category ? this.cats[this.category] : ''))
        if (this.job) notes.push('Вид работ: ' + (this.job ? this.cats[this.job] : ''))
        if (this.problem) notes.push('Проблема: ' + this.problem)
        if (this.stock) notes.push('Акция: ' + this.stock)
        if (this.date || this.time) notes.push('Дата время записи: ' + this.date + ' ' + this.time)
        formData.append('crm', '1')
        formData.append('pipe', '1')
        formData.append('contact[name]', this.user.name)
        formData.append('contact[3]', this.user.phone)
        formData.append('contact[4]', this.user.email)
        formData.append('contact[17]', this.user.district)
        formData.append('contact[45]', this.cityl[this.citys])
        formData.append('contact[96]', this.promocode ? this.promocode : this.user.invite)
        formData.append('lead[5]', this.brands[this.user.mark])
        formData.append('lead[6]', this.marks[this.user.model])
        formData.append('lead[33]', this.user.year)
        formData.append('lead[34]', this.user.vin)
        formData.append('lead[69]', this.user.uid)
        formData.append('lead[67]', this.problem)
        formData.append('lead[23]', this.user.district)
        formData.append('lead[36]', this.cityl[this.citys])
        formData.append('lead[43]', this.date + ' ' + this.time)
        formData.append('lead[40]', (this.job ? this.job : this.category))
        if (this.service) formData.append('lead[41]', this.service)
        if (this.file !== null) {
          for (var i = 0; i < this.file.length; i++) {
            let file = this.file[i]
            formData.append('photo[' + i + ']', file)
          }
        }
        formData.append('note', notes.join('<br>'))
        axios.post('https://crm.v-avtoservice.com/api/import-lead',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
      }
    },
    handleFileUpload () {
      this.file = this.$refs.file.files
    }
  },
  mounted () {
    this.cityl[this.city.id] = this.city.name
    var $this = this
    $('#order-form-city').select2({
      placeholder: 'Выберите город',
      ajax: {
        delay: 250,
        type: 'POST',
        url: 'https://crm.v-avtoservice.com/list/site-get-cities',
        dataType: 'json',
        data: function (params) {
          params.lang = $this.$root.city.lang
          params.q = params.term
          return params
        },
        processResults: function (data) {
          return {
            results: $.map(data, function (item) {
              $this.cityl[item.id] = item.text
              return {
                text: item.text,
                id: item.id
              }
            })
          }
        }
      }
    }).change(function (data) {
      $this.citys = $(this).val()
    })
    $('#select-add-field_select').select2({
      placeholder: 'еще..'
    })
    $('#order-form-mark').select2({
      placeholder: 'Выберите Марку',
      ajax: {
        delay: 250,
        type: 'POST',
        url: 'https://crm.v-avtoservice.com/list/site-get-marks',
        dataType: 'json',
        processResults: function (data) {
          let res = $.map(data, function (item) {
            $this.brands[item.id] = item.name
            return {
              text: item.name,
              id: item.id
            }
          })
          return {
            results: res
          }
        }
      }
    }).change(function (data) {
      $this.user.mark = $(this).val()
      $('#order-form-model').val(null).trigger('change').prop('disabled', false)
    })

    $('#order-form-model').select2({
      placeholder: 'Выберите Модель',
      ajax: {
        delay: 250,
        type: 'POST',
        data: function (params) {
          params.brend_id = $this.user.mark
          params.q = params.term
          return params
        },
        url: 'https://crm.v-avtoservice.com/list/site-get-models',
        dataType: 'json',
        processResults: function (data) {
          return {
            results: $.map(data, function (item) {
              $this.marks[item.id] = item.name
              return {
                text: item.name,
                id: item.id
              }
            })
          }
        }
      }
    }).change(function (data) {
      $this.user.model = $(this).val()
    })

    $('#order-form-category-parent').select2({
      placeholder: 'Выберите категорию',
      ajax: {
        url: 'https://crm.v-avtoservice.com/list/site-get-cats',
        dataType: 'json',
        data: function (param) {
          param.q = param.term
          return param
        },
        processResults: function (data) {
          return {
            results: $.map(data, function (item) {
              $this.cats[item.id] = item.title
              return {
                text: item.title,
                id: item.id
              }
            })
          }
        }
      }
    }).change(function (data) {
      $this.category = $(this).val()
      console.log($this.category)
      if ($this.category === '170') $this.$router.push('avtoyurist')
      $('#order-form-category').val(null).trigger('change').prop('disabled', false)
    })

    $('#order-form-category').select2({
      placeholder: 'Выберите вид работы',
      ajax: {
        url: 'https://crm.v-avtoservice.com/list/site-get-jobs',
        dataType: 'json',
        data: function (param) {
          if ($this.category) {
            param.parent_id = $this.category
          }
          param.q = param.term
          return param
        },
        processResults: function (data) {
          return {
            results: $.map(data, function (item) {
              $this.cats[item.id] = item.title
              return {
                text: item.title,
                id: item.id
              }
            })
          }
        }
      }
    }).change(function (data) {
      $this.job = $(this).val()
    })
    $('#select-add-field select').change(function () {
      var $this = $(this)
      $('#application .addfield' + $this.val()).removeAttr('style')
      $this.find('option[value=' + $this.val() + ']').remove()
      if ($this.find('option').length < 2)$('#select-add-field').remove()
      return false
    })
    Inputmask().mask(document.querySelectorAll('input'))
  }
}
</script>

<style scoped>
    #select-add-field .select2-container--default .select2-selection--single {
         border: 1px solid #3290d0;
     }

    #select-add-field .select2-container--default .select2-selection--single .select2-selection__rendered {
        color: #3290d0;
    }

    #select-add-field .select2-selection__arrow:before {
        content: '+';
        color: #3290d0;
        display: block;
        width: 30px;
        height: 26px;
        background: #fff;
        padding: 0 0 0 8px;
        line-height: 26px;
        z-index: 111111;
        position: absolute;
        font-size: 24px;
        margin: 6px 0 0 -14px;
        border-left: 1px solid #d4d4d4;
    }
</style>



// WEBPACK FOOTER //
// src/components/blocks/index-sokr.vue